import React from "react";
import {useContext} from "react";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {StoreContext} from "../../../store/StoreContext";

const Home = () => {
  const navigate = useNavigate();

  const {setAppTitle} = useContext(StoreContext);

  useEffect(() => {
    setAppTitle("SSO Shield");
  }, []);

  return (
    <div className="row mt-5">
      <div className="col-12 col-md-3 mx-auto">
        <button
          type="button"
          className="btn bg-primary text-white btn-lg mb-3 w-100"
          onClick={() => navigate("/cermaq/Index")}
        >
          Seguridad y Salud Ocupacional
        </button>
      </div>

      {/* <div className="col col-md-3 me-md-auto">
        <button
          type="button"
          className="btn bg-primary text-white btn-lg mb-3 me-md-auto ms-md-4 w-100"
          disabled
        >
          Capacitación
        </button>
      </div> */}
    </div>
  );
};

export default Home;
